import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { Events, OnClick } from "../../../library-js/dom-tools/EventListeners";
import { Func } from "../../../library-js/tools/TypeUtilities";
import { InspectorContainer } from "../containers/InspectorContainer";
import { InspectorField } from "../fields/InspectorField";
import { InspectorCreationInfo } from "../InspectorCreationInfo";
import { CallbackButton } from "./CallbackButton";


export class CallbackButtonField extends InspectorField<any>
{
  static readonly type = new ElementType( "callback--button--field" );
  
  static readonly flag = new ClassFlag( "callback--button" );
    
  createElement() 
  {    
    let element = CallbackButtonField.type.create();    
    this._element = element;    
  }

  onAddedToContainer()
  {
    super.onAddedToContainer();

    let button = InspectorContainer.containerName.query( this.container );

    CallbackButtonField.flag.set( button );

    OnClick.add( button as HTMLElement, 
      ( e )=>
      {   
        ( this.info.object as CallbackButton ).callback();
      } 
    );
  }
  
} 

